import { Component } from "@angular/core";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDialogContent, MatDialogClose } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-skill-resource-add",
  templateUrl: "./skill-resource-add.component.html",
  styleUrls: ["./skill-resource-add.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatDialogClose,
    RouterLink,
    TranslatePipe
  ]
})
export class SkillResourceAddComponent {}
